<div class="modal-header">
  <button
    type="button"
    class="btn-close"
    (click)="bsModalRef.hide()"
    aria-label="Close"
  >
    <i class="feather x"></i>
  </button>
  <h4 class="modal-title" id="myModalLabel">My Devices</h4>
</div>

<div class="modal-body" style="display: flex; flex-direction: column">
  <div *ngFor="let _d of devices" class="device-list">
    <div class="date device-item">
      <div class="device-item-header">Most Recent Login</div>
      <p>
        {{
          _d.last_login_dt
            | amFromUtc
            | amLocal
            | amDateFormat: "MMM, Do YYYY, h:mm A"
        }}
      </p>
    </div>
    <div class="ip device-item">
      <div class="device-item-header">IP Address</div>
      <p>{{ _d.ip_address }}</p>
    </div>
    <div class="browser device-item">
      <div class="device-item-header">
        Browser {{ client_id == _d.client_id ? "(This Device)" : null }}
      </div>
      <p>{{ _d.device }}</p>
    </div>
    <div class="actions device-item" *ngIf="client_id != _d.client_id">
      <div class="device-item-header">Actions</div>
      <i
        class="feather x-circle"
        (click)="removeDevice(_d.uuid)"
        alt="Remove device"
      ></i>
    </div>
  </div>
</div>
